import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface RankingEntry { id: string | null; name: string; count: number }

/** Klickbare Rangliste mit Balken und Anteil — ein Klick filtert das Dashboard auf den Eintrag. */
@Component({
  selector: 'app-activity-ranking',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './activity-ranking.component.html',
  styleUrls: ['./activity-ranking.component.scss'],
})
export class ActivityRankingComponent {
  @Input() entries: RankingEntry[] = [];
  /** Gesamtzahl der Kachel-Aufrufe, Basis für den Prozentanteil. */
  @Input() total = 0;
  @Input() disabled = false;
  @Input() emptyIcon = 'ri-bar-chart-2-line';
  @Output() pick = new EventEmitter<string>();

  percent(count: number, base: number): number {
    return base > 0 ? count / base * 100 : 0;
  }
}
